"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationEntity = void 0;
class TranslationEntity {
    /**
     * @deprecated
     */
    _id;
    id;
    key;
    translations;
    /**
     * @deprecated
     */
    update_at;
    /**
     * @deprecated
     */
    create_at;
    createdAt;
    updatedAt;
}
exports.TranslationEntity = TranslationEntity;
